import useStrings from "../../../localization/useStrings"
import svg from "../../../utils/svg"
import styles from "./PremiumPromoFeatureList.module.scss"

interface Feature {
  title: string
  description: string
  inconSvg: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
}

const PremiumPromoFeatureList = () => {
  const strings = useStrings()

  const features: Feature[] = [
    {
      title: strings.expiration.warmup.features.cloudVault.title,
      description: strings.expiration.warmup.features.cloudVault.subtitle,
      inconSvg: svg.featureIcons.CloudVault,
    },
    {
      title: strings.expiration.warmup.features.noAds.title,
      description: strings.expiration.warmup.features.noAds.subtitle,
      inconSvg: svg.featureIcons.Adfree,
    },
    {
      title: strings.decoy,
      description: strings.emailPromo.decoyDescription,
      inconSvg: svg.featureIcons.Decoy,
    },
    {
      title: strings.trashRecovery,
      description: strings.bubbleExpiration.recoverDeleted,
      inconSvg: svg.featureIcons.Trash,
    },
  ]

  return (
    <div className={styles.container}>
      {features.map((feature, index) => (
        <FeatureListItem key={index} {...feature} />
      ))}
    </div>
  )
}

const FeatureListItem = ({
  title,
  description,
  inconSvg: Icon,
}: Feature) => {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.iconContainer}>
        <Icon fill="white" />
      </div>
      <div className={styles.textContainer}>
        <div className={styles.titleContainer}>
          <label className={styles.title}>{title}</label>
        </div>
        <label className={styles.description}>{description}</label>
      </div>
    </div>
  )
}

export default PremiumPromoFeatureList